import React from 'react';
import TableV2 from './TableV2';
import { useContext } from 'react';
import AdminContext from '../../Context/adminContext';

const CompanyContactsTable = ({ contacts, clickableRowAdd, onDetachProfessional }) => {
  const editable = useContext(AdminContext);

  if (!contacts || contacts.length === 0) {
    return <p>No company contacts available.</p>;
  }

  // Reformat the data for TableV2
  const formattedData = {
    headers: ['ID', 'Name', 'Email', 'Phone Number', 'Actions'],
    rows: contacts.map(contact => [
      contact.ID,
      contact.Name,
      contact.Email,
      contact.Phone,
      // Actions column with unlink button for admins
      editable ? {
        type: 'action',
        actions: [
          {
            label: 'Unlink',
            onClick: () => onDetachProfessional && onDetachProfessional(contact.ID)
          }
        ]
      } : ''
    ]),
    dataName: 'CompanyContacts'
  };

  return (
    <div style={{ marginBottom: '24px' }}>
      <TableV2 data={formattedData} clickableRowAdd={clickableRowAdd} />
    </div>
  );
};

export default CompanyContactsTable; 